import Add from '@mui/icons-material/Add'
import { Box, IconButton, Stack } from '@mui/material'
import { OrderHoldsSectionStore } from '@planning/components/hold/organisms/stores/OrderHoldsSectionStore'
import { HoldsFormContent } from '@planning/pages/Holds/organisms/HoldsFormContent'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface Props {
  open: boolean
  isLoading?: boolean
  store: OrderHoldsSectionStore | null
  onClose: () => void
  onConfirm: () => void
}

export const AddHoldDialog = observer(({ open, isLoading, store, onClose, onConfirm }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <ConfirmationDialog
      open={open}
      title={t('addHold', 'Add hold')}
      maxWidth='md'
      primaryActionText={t('save', 'Save')}
      closeLabel={t('cancel', 'Cancel')}
      isLoading={isLoading}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      {store && (
        <Stack gap={theme.customSpacing.m} sx={{ pt: theme.customSpacing.xs }}>
          <HoldsFormContent store={store} />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton size='small' onClick={store.addHold}>
              <Add fontSize='small' />
            </IconButton>
          </Box>
        </Stack>
      )}
    </ConfirmationDialog>
  )
})
